import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { RefreshCw } from "lucide-react";

export default function AdminLogsTab({ apiUrl, getAuthHeaders }) {
  const credFetch = (url, opts = {}) => fetch(url, { ...opts, credentials: "include" });

  const [activityLogs, setActivityLogs] = useState([]);

  useEffect(() => { loadActivityLogs(); }, []);

  const loadActivityLogs = async () => {
    try {
      const res = await credFetch(`${apiUrl}/api/admin/activity-logs`, { headers: getAuthHeaders(), credentials: "include" });
      const data = await res.json();
      if (data.success) setActivityLogs(data.logs);
    } catch (error) { console.error("Activity logs error:", error); }
  };

  return (
    <div className="space-y-6" data-testid="admin-logs-tab">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Activity Logs</h2>
        <Button variant="outline" onClick={loadActivityLogs}><RefreshCw className="w-4 h-4 mr-2" />Refresh</Button>
      </div>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Action</TableHead><TableHead>Admin</TableHead><TableHead>Details</TableHead><TableHead>Timestamp</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {activityLogs.length === 0 ? (
              <TableRow><TableCell colSpan={4} className="text-center text-gray-500 py-8">No activity logs yet</TableCell></TableRow>
            ) : (
              activityLogs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell><Badge className={log.action.includes("ban") ? "bg-red-100 text-red-700" : log.action.includes("export") ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-700"}>{log.action.replace("_", " ")}</Badge></TableCell>
                  <TableCell>{log.admin_email}</TableCell>
                  <TableCell className="text-sm text-gray-500">{log.user_id ? `User: ${log.user_id}` : "-"}</TableCell>
                  <TableCell className="text-sm text-gray-500">{new Date(log.timestamp).toLocaleString()}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
